import api from 'api';

const activateUserUrl = 'api/email/verify/:id/:token';

export default {
    activateUser: ({ id, token, expires, signature }) => api.get({path: activateUserUrl.replace(':token', token).replace(':id', id), params: {expires, signature}}),
}